export default "/images/ca4de7cab063dbd1a82ad7a079d07519.jpg";